// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum CustomerRefundApplicationReason {
  ChargeDuplicityExists = "CHARGE_DUPLICITY_EXISTS",
  IncorrectLicensePlate = "INCORRECT_LICENSE_PLATE",
  IncorrectCountryId = "INCORRECT_COUNTRY_ID",
  ExemptedVehicle = "EXEMPTED_VEHICLE",
  VehicleWithoutChargeObligation = "VEHICLE_WITHOUT_CHARGE_OBLIGATION",
  IncorrectAndCheaperFuelType = "INCORRECT_AND_CHEAPER_FUEL_TYPE",
  IncorrectAndMoreExpensiveFuelType = "INCORRECT_AND_MORE_EXPENSIVE_FUEL_TYPE",
  MoreExpensiveFuelTypeDueToIncorrectDataInVehicleRegister = "MORE_EXPENSIVE_FUEL_TYPE_DUE_TO_INCORRECT_DATA_IN_VEHICLE_REGISTER",
  Other = "OTHER",
}

export default CustomerRefundApplicationReason;
